module.exports = __webpack_public_path__ + "img/name.d8db5051.png";